import React from 'react';
import './partners.css'
import {
    Card, CardText, CardBody,
    CardTitle, CardSubtitle
} from 'reactstrap';

var Translate = require('react-translate-component')

export default class ReferenceCard extends React.Component {
    render() {
        return (
            <Card className="mt-5" id="refCard" >
                <CardBody className="refCardBody">
                    <CardText className="refCardText">{this.props.refText}</CardText>
                        <div className="refSign">
                            <CardSubtitle className="refCardName">{this.props.refName}</CardSubtitle>
                            <CardTitle className="refCardProfession"><Translate content={this.props.refProfession} /></CardTitle>
                        </div>
                  
                </CardBody>
            </Card>
        );

    };

}